$(function(){
    $('.b-image-heading').each(function(){
        var $context = $(this),
            $titleBlock = $('.b-image-heading__title', $context);
        if($titleBlock.find('h1').text().length < 2) {
            $titleBlock.addClass('is-empty');
        }
    });
});